<div class="modal-header">
  <h6 class="modal-title">{{ news.title }}</h6>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>

<div class="modal-body">
  <img [src]="imageService.getImageUrl(news.image)" class="img-fluid rounded w-100" alt="News Image">
  <p class="text-muted mb-1"><small>📅 {{ news.publishedAt | date:'dd MMM yyyy' }}</small></p>
  <div [innerHTML]="news.content"></div>
</div>
